export default function getResource(label) {
    const resources = {
        shopNow: 'Shop now',
        video: 'Video'
    };

    return resources[label];
}
